import { Button } from '@codegouvfr/react-dsfr/Button';
import { RncpAjoutDto } from '@common/services/rncp';
import { defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React, { CSSProperties } from 'react';

export const RncpItem = ({ rncp, order, onDelete }: RncpItemProps) => {
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: rncp.id,
    animateLayoutChanges: defaultAnimateLayoutChanges,
  } as never);

  const contents: Content[] = [
    { title: 'RNCP', value: rncp.rncp },
    { title: 'Code diplôme', value: rncp.codeDiplome },
    { title: 'Libellé', value: rncp.libelle },
    { title: 'Code spécialité', value: rncp.codeSpecialite },
    { title: 'Type de certification', value: rncp.typeCertification },
    { title: 'Niveau de certification', value: rncp.niveauCertification },
  ];

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: (isDragging) ? 1000 : 'auto',
  };

  return (
    <div ref={setNodeRef}
         className={'flex flex-col p-4 border border-[#ddd] rounded bg-white border-box cursor-pointer'}
         style={style}
         {...attributes}
         {...listeners}>

      <div className={'flex'}>

        <div className={'flex flex-1'}>
          <h6>{order}. {rncp.libelle}</h6>
        </div>

        <div onPointerDown={(ev) => ev.stopPropagation()}>
          <Button iconId="fr-icon-delete-fill"
                  className="text-red-500! border-red-500! shadow-none! m-1!"
                  priority="tertiary"
                  onClick={() => onDelete()} />
        </div>
      </div>

      <div className={'grid grid-cols-2 md:grid-cols-3 gap-4'}>
        {contents.map(({ title, value }, index) => (
          <div key={`${index}-${title}`} className={'flex flex-col gap-2'}>
            <span className={'text-(--text-label-blue-france)'}>{title}</span>
            <span className={'text-(--text-title-grey)'}>{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

interface RncpItemProps {
  rncp: RncpAjoutDto;
  order: number;
  onDelete: () => void;
}

interface Content {
  title: string;
  value: string;
}